// 通用协议弹窗 - 适用于协议内容参数名为content的coupe配置协议
import './reset.less';
import { useState, useEffect } from 'react';
// import { coupeIdMap } from './config';
import { ResetModal } from '../modal';
import { getCoupeData } from '@/apis/apis';

interface PrivacyModalProps {
  coupeId: string;
  name?: string;
  title: string;
  visible: boolean;
  close: () => void;
}

export default function PrivacyModal(props: PrivacyModalProps) {
  const [coupeData, setCoupeData] = useState<any>({});
  const { coupeId, name, title, visible, close } = props;
  useEffect(() => {
    if (!coupeId && coupeData?.content) {
      // 若无id，清除内容缓存，coupe json会缓存在本地不会重新请求
      setCoupeData({});
    }
    if (!visible || coupeData?.content) {
      return;
    }
    if (coupeId) {
      getCoupeData({ coupeId, name }).then((rs) => {
        setCoupeData(rs);
      });
    } else {
      console.error(new Error('coupeKey必填'));
    }
  }, [visible, coupeData, coupeId, name]);
  return (
    <ResetModal
      visible={visible}
      title={title}
      onClickCloseBtn={close}
      footer={null}
      width={736}
      className='common-privacy-modal'
    >
      <div className='common-privacy'>
        <div className='protocol-content'>
          <div dangerouslySetInnerHTML={{ __html: coupeData?.content }}></div>
        </div>
      </div>
    </ResetModal>
  );
}
